import { TaskTableModel } from '../../api/Argentia/endpoints/tasks/model/tasks'
import { TaskFormSearchFilter } from '../../pages/tasks/components/searchFilterCardTasks/searchFilterCardTasks'

export enum TasksActionTypes {
  STORE_SHOW_TASKS = 'STORE_SHOW_TASKS',
  STORE_SHOW_FILTER_CARD = 'STORE_SHOW_FILTER_CARD',
  STORE_TASKS_DATATABLE = 'STORE_TASKS_DATATABLE',
  STORE_TASKS_SEARCHFILTERS = 'STORE_TASKS_SEARCHFILTERS'
}

export interface StoreShowTasksAction {
  type: TasksActionTypes
  payload: boolean | null
}

export interface StoreTasksDatatableAction {
  type: TasksActionTypes
  payload: TaskTableModel[] | null
}

export interface StoreTasksSearchFilterAction {
  type: TasksActionTypes
  payload: TaskFormSearchFilter | null
}

export const storeShowTasksAction = (showState: boolean): StoreShowTasksAction => {
  return { type: TasksActionTypes.STORE_SHOW_TASKS, payload: showState }
}

export const storeShowFilterCardAction = (showFilterCard: boolean): StoreShowTasksAction => {
  return { type: TasksActionTypes.STORE_SHOW_FILTER_CARD, payload: showFilterCard }
}

export const storeTasksSearchFilters = (
  filters: TaskFormSearchFilter
): StoreTasksSearchFilterAction => {
  return { type: TasksActionTypes.STORE_TASKS_SEARCHFILTERS, payload: filters }
}

export const storeTasksDatatableAction = (
  tasksDataTable: TaskTableModel[]
): StoreTasksDatatableAction => {
  return { type: TasksActionTypes.STORE_TASKS_DATATABLE, payload: tasksDataTable }
}
